import React from 'react';
import { motion } from 'framer-motion';
interface SlideProps {
  index: number;
  total: number;
}
export function Slide01Title({
  index
}: SlideProps) {
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--bg)]" data-id="element-11">
      {/* Hero image with overlay */}
      <div className="absolute inset-0" data-id="element-12">
        <img src="https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1920&q=80" alt="Medical conference speaker" className="w-full h-full object-cover" data-id="element-13" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-black/20" data-id="element-14" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-between p-[clamp(2rem,4vw,4rem)]" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} className="flex-1 flex flex-col justify-center max-w-4xl" data-id="element-16">
          <h1 className="text-white font-bold text-[clamp(3rem,7vw,6rem)] leading-[0.95] mb-[clamp(1rem,2vw,2rem)]" data-id="element-17">
            From Webinar
            <br data-id="element-18" />
            To Series
          </h1>
          <p className="text-white/90 text-[clamp(1.25rem,2.5vw,2rem)] font-medium max-w-3xl" data-id="element-19">
            Transform every DERMX webinar into weeks of HCP engagement
          </p>

          {/* Progression chip */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6,
          duration: 0.5
        }} className="mt-[clamp(2rem,4vw,3rem)] inline-flex items-center gap-3 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-6 py-3 w-fit" data-id="element-20">
            <span className="text-white font-medium text-[clamp(0.875rem,1.5vw,1.125rem)]" data-id="element-21">
              Live Event
            </span>
            <span className="text-white/60" data-id="element-22">→</span>
            <span className="text-white font-medium text-[clamp(0.875rem,1.5vw,1.125rem)]" data-id="element-23">
              Episodes
            </span>
            <span className="text-white/60" data-id="element-24">→</span>
            <span className="text-white font-medium text-[clamp(0.875rem,1.5vw,1.125rem)]" data-id="element-25">
              Full Webinar
            </span>
          </motion.div>
        </motion.div>

        {/* Bottom statement */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8,
        duration: 0.6
      }} className="flex justify-between items-end" data-id="element-26">
          <p className="text-white/80 text-[clamp(1rem,1.75vw,1.5rem)] max-w-2xl font-medium" data-id="element-27">
            One webinar can become an evergreen educational content franchise.
          </p>
          <span className="text-white/60 text-sm" data-id="element-28">{index + 1}</span>
        </motion.div>
      </div>
    </div>;
}